// depend
import Pusher from "pusher-js";

export const pusher = new Pusher("3112403ed6f282b5a661", { cluster: "ap2" })